import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {RouterModule} from '@angular/router';

@Component({
  selector: 'app-settings-button-widget',
  templateUrl: './settings-button-widget.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  styleUrls: ['./settings-button-widget.component.scss']
})
export class SettingsButtonWidgetComponent implements OnInit {
  @Input('title') title;
  @Input('iconPath') iconPath;
  @Input('clickNav') clickNav;

  ngOnInit(): void {
  }

  navigateTo() {
    window.location.href = this.clickNav;
  }
}
